<template>
  <div class="hello">
    <b-row>
    <Header />
    <b-col cols="2" class="left-side"><PostDiceNav /></b-col>
    <b-col class="right-side"><Requisition /></b-col>
  </b-row>
  </div>
</template>

<script>
import Header from './Header.vue'
import PostDiceNav from './PostDiceNav.vue'
import Requisition from './Requisition.vue'

export default {
  name: 'PostDice',
  components: {
    Header,
    PostDiceNav,
    Requisition
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.left-side{
  height: auto;
  border: 2px inset;
      padding-left: 60px;
    padding-right: 30px;
}
.right-side{
  height: auto;
  border: 2px inset;
  margin-left: 2px;
  background: #fff;
}
.list-group-item{
  text-align: center;
      padding: 1rem 0rem;
}
</style>
